var randomNumberModalTemplate = require('./random-number-modal.handlebars');
var randomNumberNumbersTemplate = require('./random-number-numbers.handlebars');
var printLogs=false;

$(function () {
    let $modalTriggers = $('.random-number-generator-modal-trigger');

    //if no triggers, return
    if (!$modalTriggers.length) return;

    const randomNumberGeneratorModalBaseId = "#random-number-generator-modal-";

    //Create modal for each trigger found on page
    $modalTriggers.each((i, el) => {
        let $this = $(el);
        let gameId = $this.data("game-id");
        let modalId = `${randomNumberGeneratorModalBaseId}${gameId}`;

        $this.attr("data-toggle", "modal");
        $this.attr("data-target", modalId);

        createRngModal(gameId, modalId);
    });

});

function createRngModal(gameId, modalId) {
    //create modal and append to body
	if(printLogs){
	console.log('GameID:'+gameId+'ModelID:'+modalId);}
    $.ajax({
        url: `/api/v1/drawgames/${gameId}/nextDrawing`,
        type: 'GET'
    })
        .done(function (data) {
			if(printLogs){
			console.log(data);
			console.log(data.data);
			}
            let html = randomNumberModalTemplate({ modalData: data.data });
            $('body').append(html);
            initializeRngModalEvents(gameId, modalId);
        });
}

function initializeRngModalEvents(gameId, modalId) {
    //ON SHOW, get initial random numbers to display
    $(modalId).on('show.bs.modal', function () {
        updateRandomNumbers(gameId, modalId);
    });

    //ON .btn-generate-random-numbers click, get new random numbers to display
    $(modalId).find('.btn-generate-numbers').on('click', () => {
        updateRandomNumbers(gameId, modalId);
    })
}

function updateRandomNumbers(gameId, modalId) {
    let $randomNumberContainer = $(`${modalId} .random-number-container`);
    let requestedPlayCount = 5;

    $.ajax({
        url: `/api/v1/drawgames/${gameId}/randomNumber`,
        type: 'POST',
        data: { 'totalNumbers': requestedPlayCount },
        dataType: 'json'
    })
        .done(function (data) {
            let html = randomNumberNumbersTemplate({ plays: data.data });
            $randomNumberContainer.html(html);
        });
}


// WEBPACK FOOTER //
// ./features/random-number-generator/random-number-generator.js